// extracted by mini-css-extract-plugin
export default {"formWrap":"CommonStrategyDetail_formWrap__WjwXY","tableFolding":"CommonStrategyDetail_tableFolding__c7AhZ"};